'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024 from "./com.raquo.airstream.core.-Airstream-Error$.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dVar$002dError from "./com.raquo.airstream.core.-Airstream-Error$-Var-Error.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dDerived$002dVar$002dSignal from "./com.raquo.airstream.state.-Derived-Var-Signal.js";
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar from "./com.raquo.airstream.state.-Lazy-Derived-Var.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d from "./scala.scalajs.runtime.-Anon-Function0.$$-Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
import * as $j_scala$002eutil$002e$002dFailure from "./scala.util.-Failure.js";
import * as $j_scala$002eutil$002e$002dSuccess from "./scala.util.-Success.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_state_DerivedVar(parent, zoomIn, zoomOut, owner, displayNameSuffix) {
  this.EY = null;
  this.yM = null;
  this.v2 = null;
  this.EZ = null;
  this.EX = null;
  this.yL = null;
  this.v3 = null;
  this.v2 = parent;
  this.EZ = zoomOut;
  this.EX = displayNameSuffix;
  this.EY = (void 0);
  $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar.$f_Lcom_raquo_airstream_state_Var__$init$__V(this);
  this.yL = new $j_com$002eraquo$002eairstream$002estate$002e$002dDerived$002dVar$002dSignal.$c_Lcom_raquo_airstream_state_DerivedVarSignal(parent, zoomIn, owner, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d.$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this))));
  this.v3 = this.yL;
}
export { $c_Lcom_raquo_airstream_state_DerivedVar as $c_Lcom_raquo_airstream_state_DerivedVar };
$p = $c_Lcom_raquo_airstream_state_DerivedVar.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_state_DerivedVar;
/** @constructor */
function $h_Lcom_raquo_airstream_state_DerivedVar() {
}
export { $h_Lcom_raquo_airstream_state_DerivedVar as $h_Lcom_raquo_airstream_state_DerivedVar };
$h_Lcom_raquo_airstream_state_DerivedVar.prototype = $p;
$p.dP = (function() {
  return this.EY;
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.uI = (function() {
  return this.yM;
});
$p.Bg = (function(x$0) {
  this.yM = x$0;
});
$p.lh = (function() {
  return this.yM;
});
$p.rl = (function(value, transaction) {
  if ($j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this.yL)) {
    matchResult1: {
      var x1 = this.v2.a4().b3();
      if ((x1 instanceof $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success)) {
        var parentValue = x1.e5;
        this.v2.rl(value.ra(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => this.EZ.bB(parentValue, _$1)))), transaction);
        break matchResult1;
      }
      if ((x1 instanceof $j_scala$002eutil$002e$002dFailure.$c_s_util_Failure)) {
        var err = x1.h8;
        $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb(new $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dVar$002dError.$c_Lcom_raquo_airstream_core_AirstreamError$VarError("Unable to zoom out of derived var when the parent var is failed.", new $j_java$002elang$002e$002dObject.$c_s_Some(err)));
        break matchResult1;
      }
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x1);
    }
  } else {
    $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb(new $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dVar$002dError.$c_Lcom_raquo_airstream_core_AirstreamError$VarError((("Unable to set current value " + value) + " on inactive derived var"), $j_java$002elang$002e$002dObject.$m_s_None$()));
  }
});
$p.a4 = (function() {
  return this.v3;
});
$p.dd = (function() {
  return (("" + $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this.v2)) + this.EX);
});
$p.dS = (function() {
  return this.v3;
});
var $d_Lcom_raquo_airstream_state_DerivedVar = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_state_DerivedVar, "com.raquo.airstream.state.DerivedVar", ({
  hf: 1,
  a1: 1,
  au: 1,
  aP: 1,
  M: 1,
  c4: 1
}));
export { $d_Lcom_raquo_airstream_state_DerivedVar as $d_Lcom_raquo_airstream_state_DerivedVar };
